import { useEffect } from 'react';

export const APP_TITLE = 'Ark';

/** `document.title` from the parts ("Page | Space | Ark"); empty parts are dropped. */
export function formatTabTitle(parts: string | (string | null | undefined)[] | undefined): string {
    const list = (Array.isArray(parts) ? parts : [parts]).filter((part): part is string => !!part && part.trim() !== '');
    return [...list, APP_TITLE].join(' | ');
}

/** Sets `document.title` to "<parts> | Ark" while mounted (for screens that do not render a `Page`). */
export function useTabTitle(parts: string | (string | null | undefined)[] | undefined) {
    const title = formatTabTitle(parts);
    useEffect(() => {
        document.title = title;
    }, [title]);
}
